import VueRouter, { RouteConfig } from 'vue-router'
import Index from '../views/academy-mgt/Index.vue'

export const academyHome: RouteConfig = {
  path: '/academy-home',
  name: 'academy_home',
  component: Index,
  meta: {
    title: '学院管理',
  },
}
export default [academyHome]

export function navigateToAcademyHome(router: VueRouter) {
  router.push({ name: academyHome.name })
}
